<template>
  <div class="d-flex justify-end" :class="align">
    <VRating
      v-model="stars"
      :color="ratingColor"
      :hover="true"
      :hover-color="ratingColor"
      dense
      background-color="grey darken-1"
      :size="size"
      :readonly="readonly"
      :half-increments="halfIncrements"
    />
  </div>
</template>

<script>

export default {
  name: 'CandidateRating',
  props: {
    candidate: {
      type: Object,
      required: true,
    },
    size: {
      type: [Number, String],
      default: 16,
    },
    readonly: {
      type: Boolean,
      default: true,
    },
    align: {
      type: String,
      default: 'align-start',
    },
  },
  computed: {
    isManualRatingSet() {
      return !!this.candidate.rating;
    },
    stars: {
      get() {
        if (this.isManualRatingSet) {
          return this.candidate.rating;
        }

        const ai = this.candidate.interview?.aiRating ?? this.candidate.aiRating;

        if (!ai) { return 0; }

        return ai ? ai / 2 : 0.5;
      },
    },
    halfIncrements() {
      return !this.isManualRatingSet;
    },
    ratingColor() {
      return this.isManualRatingSet ? 'yellow accent-4' : 'blue accent-2';
    },
  },
};

</script>
